<i18n>
{
  "en":{
    "Label": "Close"
  },
  "fr":{
    "Label": "Fermer"
  }
}
</i18n>

<template>
  <button
    :type="type"
    class="btn btn-secondary"
    @click="$emit('click')">
    <IconClose />
    <span class="d-inline-block ml-2">{{ computedLabel }}</span>
  </button>
</template>

<script>
import { computed, props } from '.';

export default {
  props,
  computed,
};
</script>
